import { createApp, defineAsyncComponent } from "vue";
import App from "./App.vue";
import { router } from "./router";
import { createPinia } from "pinia";
import { getPdfMake } from "@/js/pdfmakeInstance.js";
import AmountDisplay from "./components/AmountDisplay.vue";

// --- Styles & Global Assets ---
import "@/assets/styles.scss";
import "@/assets/tailwind.css";
import 'primeicons/primeicons.css';
import '@fortawesome/fontawesome-free/css/all.css';

// Core Components
import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";

// Services & Directives
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";
import Ripple from "primevue/ripple";
import StyleClass from "primevue/styleclass";
import Toast from "primevue/toast";

const NepaliCalendar = defineAsyncComponent(
  () => import("@/components/nepali-date-picker/NepaliCalendar.vue")
);


const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);
app.component('AmountDisplay', AmountDisplay);

// PrimeVue Setup
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: ".app-dark",
    },
    cssLayer: {
      name: "primevue",
      order: "tailwind-base, primevue, tailwind-utilities",
    },
  },
  ptOptions: {
    mergeSections: true,
    mergeProps: false,
  },
  ripple: true,
  pt: {
    dataTable: {
      root: {
        class: "p-datatable-sm p-datatable-striped p-datatable-gridlines",
      },
      column: {
        pcColumnFilterButton: {
          style: { display: "none" },
        },
        bodyCell: {
          style: {
            "word-wrap": "break-word",
            "overflow-wrap": "break-word",
            "word-break": "break-word ",
          },
        },
      },
    },
    autocomplete: {
      virtualScroller: {
        root: {
          style: { "min-width": "23rem !important" },
        },
      },
    },
    dropdown: {
      wrapper: {
        style: { "min-width": "23rem !important" },
      },
    },
  },
});

// Directives and Services Registration
app.directive("ripple", Ripple);
app.directive("styleclass", StyleClass);
app.directive("tooltip", Tooltip);

app.use(ToastService);
app.use(ConfirmationService);

// Component Registration
app.component("NepaliCalendar", NepaliCalendar);
app.component("Toast", Toast);

app.mount("#app");

/** * PREFETCH LOGIC
 * This runs after the app is loaded to cache the heavy PDF libraries 
 * in the background without blocking the main thread.
 */
if (window.requestIdleCallback) {
  console.log("Scheduling immediate PDF prefetch using requestIdleCallback...");
  window.requestIdleCallback(() => {
    getPdfMake();
  });
} else {
  console.warn("requestIdleCallback not supported. Falling back to immediate setTimeout for PDF prefetch.");
  setTimeout(getPdfMake, 100);
}